export type ExportColumnsUserId = string | number | undefined;

const KEY_PREFIX = 'exportColumnsPreference';

const keyFor = (userId: string | number) => `${KEY_PREFIX}:${userId}`;

export const getExportColumnsPreference = (userId: ExportColumnsUserId): string[] | null => {
  if (userId === undefined) return null;
  try {
    const raw = localStorage.getItem(keyFor(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const setExportColumnsPreference = (userId: ExportColumnsUserId, keys: string[]) => {
  if (userId === undefined) return;
  try {
    localStorage.setItem(keyFor(userId), JSON.stringify(keys));
  } catch {
    return;
  }
};
